const SuccessScreen = ({ data }) => (
  <div className="bg-white shadow-md p-6 rounded-2xl border text-center">
    <div className="text-green-600 text-5xl mb-3">✔</div>

    <h2 className="text-xl font-semibold text-[#003399] mb-1">
      Transfer Successful
    </h2>

    <p className="text-gray-600 mt-2">
      ₦{data.amount} sent to {data.accountNumber} ({data.bank})
    </p>
  </div>
);

export default SuccessScreen;